module.exports = __webpack_public_path__ + "img/city (9).ef82745e.png";